// extracted by mini-css-extract-plugin
export default {"article":"BlogArticle_article__bAQ1v","designElement":"BlogArticle_designElement__TqskN","container":"BlogArticle_container__UIyx7","hero-img":"BlogArticle_hero-img__KKoxM"};